module.exports = __webpack_public_path__ + "img/bannerMobile.c9c9e29c.png";